import { render, staticRenderFns } from "./ContactToday.vue?vue&type=template&id=17ae8463&scoped=true&lang=pug&"
import script from "./ContactToday.vue?vue&type=script&lang=js&"
export * from "./ContactToday.vue?vue&type=script&lang=js&"
import style0 from "./ContactToday.vue?vue&type=style&index=0&id=17ae8463&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ae8463",
  null
  
)

export default component.exports